module.exports = __webpack_public_path__ + "static/media/saturday_west_footy2024.80730249.png";